import { onMessageListener } from '../../firebase'
import { handlePushMessage } from '../../push/handlePushMessage'
import { store } from '../../services/store'
import { requestDashboard } from '../../services/store/actions/dashboard/DashboardAction'
import DashboardActionTypes from '../../services/store/actions/dashboard/DashboardActionTypes'

export class NotificationRepository {
    private static isSubscribed = false
    private static cleanup: (() => void) | null = null

    async subscribeListener() {
        // Idempotency guard - prevent duplicate subscriptions
        if (NotificationRepository.isSubscribed) {
            console.log('[NotificationRepository] Already subscribed, skipping duplicate subscription')
            return
        }
        console.log('[NotificationRepository] Starting subscribeListener()')

        // Get the cleanup function from onMessageListener
        const cleanup = await onMessageListener(
            (msg) => {
                console.log('[NotificationRepository] Received notification:', msg)
                // Foreground: render localized text, falling back to the server body.
                // Dashboard refresh side effects are driven by scheduleRefresh() in
                // onMessageListener, so no onConsumed hook is needed here.
                handlePushMessage(msg, { bodyFallback: true })
            },
            // clearRequestInterval
            () => {
                console.log('clearRequestInterval 1')
                store.dispatch({
                    type: DashboardActionTypes.RESTART_INTERVAL,
                    payload: null,
                })
            },
            () => {
                console.log('callback 2')
                const state = store.getState()
                store.dispatch(
                    requestDashboard({
                        date: state.Dashboard.selectedDate,
                        shouldResetOpenCycles: false,
                        // [
                        //     DashboardActionTypes.SET_SELECTED_DATE,
                        // ].includes(action.type),
                    })
                )
            }
        )

        // Store the cleanup function
        NotificationRepository.cleanup = cleanup

        // Mark as subscribed to prevent duplicate subscriptions
        NotificationRepository.isSubscribed = true
        console.log('[NotificationRepository] subscribeListener() completed - listener registered')
    }

    static unsubscribe() {
        if (NotificationRepository.cleanup) {
            console.log('[NotificationRepository] Unsubscribing listener')
            NotificationRepository.cleanup()
            NotificationRepository.cleanup = null
            NotificationRepository.isSubscribed = false
        }
    }
}
